const state = {
    imagesizes:[],
};

const getters = {
    getImagesizes: state => state.imagesizes,
};

const actions = {
    setImagesizes: (store, payload) => store.commit("IMAGESIZES_SET",payload),
};

const mutations = {
    IMAGESIZES_SET: (state, payload) => state.imagesizes = payload,
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
